import { useTranslation } from 'react-i18next';
import { type TtbPaymentModuleSpecsFragment } from '../../../../../api/fragments/TtbPaymentModuleSpecs';
import {
    type CreateTtbPaymentModuleMutation,
    CreateTtbPaymentModuleDocument,
    type CreateTtbPaymentModuleMutationVariables,
} from '../../../../../api/mutations/createTtbPaymentModule';
import { type TtbPaymentModuleSettings } from '../../../../../api/types';
import InputField from '../../../../../components/fields/InputField';
import validators from '../../../../../utilities/validators';
import TtbPaymentModulePage, { type TtbPaymentModulePageProps } from '../../TtbPaymentModulePage';
import { type ModuleImplementation } from './types';

const implementation: ModuleImplementation<TtbPaymentModuleSpecsFragment, TtbPaymentModuleSettings> = {
    PageComponent: ({ module }: TtbPaymentModulePageProps) => <TtbPaymentModulePage module={module} />,
    getTitle: t => t('moduleDetails:implementations.TtbPaymentModule.className'),
    getValidator: () => validators.requiredNonEmptyString('displayName'),
    FormComponent: () => {
        const { t } = useTranslation(['moduleDetails']);

        return (
            <InputField
                {...t('moduleDetails:fields.displayName', { returnObjects: true })}
                name="displayName"
                required
            />
        );
    },
    create: async (apolloClient, companyId, values) =>
        apolloClient
            .mutate<CreateTtbPaymentModuleMutation, CreateTtbPaymentModuleMutationVariables>({
                mutation: CreateTtbPaymentModuleDocument,
                variables: {
                    companyId,
                    settings: values,
                },
            })
            .then(({ data }) => data.module),
};

export default implementation;
